module.exports = __webpack_public_path__ + "img/gold_level2.f1142891.png";